var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2592 6.40052C15.2675 6.27552 15.2758 6.15052 15.2758 6.02552C15.2758 3.39219 13.1342 1.24219 10.5008 1.24219C7.86749 1.24219 5.71749 3.39219 5.71749 6.02552C5.71749 6.15052 5.71749 6.27552 5.73416 6.40052H3.08416C2.36749 6.40052 1.79249 7.00885 1.83416 7.72552L2.02583 10.8922C2.05083 11.2505 2.34249 11.5255 2.70083 11.5255H3.35083L3.61749 18.0922C3.63416 18.4505 3.92583 18.7422 4.29249 18.7422H16.7008C17.0592 18.7422 17.3592 18.4589 17.3758 18.0922L17.6425 11.5255H18.2925C18.6508 11.5255 18.9425 11.2505 18.9675 10.8922L19.1675 7.72552C19.2092 7.00885 18.6425 6.40052 17.9175 6.40052H15.2592ZM10.5008 2.49219C12.4425 2.49219 14.0258 4.07552 14.0258 6.02552C14.0258 6.15052 14.0258 6.27552 14.0092 6.40052H6.98416C6.97583 6.27552 6.96749 6.15052 6.96749 6.02552C6.96749 4.07552 8.55083 2.49219 10.5008 2.49219ZM16.1508 17.4922H4.84249L4.60083 11.5255H16.3925L16.1508 17.4922ZM17.8342 10.2755H3.15916L2.99249 7.65052H18.0008L17.8342 10.2755Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBasket);
export default __webpack_public_path__ + "static/media/ic-basket.81514ba67d1067a6df57938bf1bd15ff.svg";
export { ForwardRef as ReactComponent };